
import { Component, Vue } from 'vue-property-decorator';
import { BASE_API_URL, REXQO_APP_ID } from '@/constants';
import { httpStore, currentUserStore } from '@/store/typed';
import { Product } from '@/models';
export enum ProductMixinTags {
	Show = "ShowProduct",
}

@Component
export default class ProductMixin extends Vue {

	getProduct(id: string) {
		const url = `${BASE_API_URL}products/${id}`;
		
		return httpStore.request({
			tag: ProductMixinTags.Show+id,
			url: url,
			headers: {'x-app-id': REXQO_APP_ID, 'locale': currentUserStore.lang},
			method: 'GET',
			}) as Promise<Product>;
	}
}
